// src/components/pages/TeamSports/BasketballEventsList.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    fetchUserBasketGames,
    createBasketGame,
} from "../../../../data-store/actions/teamgames-actions";

import {
    Box,
    Button,
    CircularProgress,
    List,
    ListItem,
    ListItemText,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
} from "@material-ui/core";

const BasketballEventsList = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const userId = useSelector((state) => state.atlete.userID);

    const teamgames = useSelector((state) => state.teamgames) || {};
    const events = teamgames.items || [];
    const loading = teamgames.loading || false;
    const error = teamgames.error || null;

    // Estado para el diálogo de nueva descripción
    const [openDialog, setOpenDialog] = useState(false);
    const [newDescription, setNewDescription] = useState("");

    useEffect(() => {
        if (userId) {
            dispatch(fetchUserBasketGames(userId));
        }
    }, [userId, dispatch]);

    const handleOpenCreateDialog = () => {
        if (!userId) return;
        setNewDescription("");
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmCreate = () => {
        const desc = newDescription.trim();
        if (!desc) return; // opcional: podrías mostrar error si está vacío

        dispatch(
            createBasketGame({
                userId,
                name: desc,              // usamos la descripción como nombre visible
                description: desc,       // por si tu acción guarda un campo extra
            })
        );

        setOpenDialog(false);
        setNewDescription("");
    };

    const handleOpenEvent = (eventId) => {
        history.push(`/basketscorergame/${eventId}`);
    };

    if (!userId) {
        return (
            <Box p={2}>
                <Typography variant="h6">
                    Debes iniciar sesión para ver tus juegos de básquet.
                </Typography>
            </Box>
        );
    }

    return (
        <Box p={2}>
            <Box
                mb={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography variant="h5">Mis juegos de básquet</Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenCreateDialog}
                >
                    Crear nuevo juego
                </Button>
            </Box>

            {loading && (
                <Box display="flex" justifyContent="center" mt={2}>
                    <CircularProgress />
                </Box>
            )}

            {error && (
                <Box mt={2}>
                    <Typography color="error">Error: {error}</Typography>
                </Box>
            )}

            {!loading && events.length === 0 && (
                <Box mt={2}>
                    <Typography>No tienes juegos creados todavía.</Typography>
                </Box>
            )}

            <List>
                {events.sort((a, b) => b.createdAt - a.createdAt).map((ev) => (
                    <ListItem
                        key={ev.id}
                        button
                        onClick={() => handleOpenEvent(ev.id)}
                    >
                        <ListItemText
                            primary={ev.name || "Juego sin nombre"}
                            secondary={ev.status ? `Estado: ${ev.status}` : null}
                        />
                    </ListItem>
                ))}
            </List>

            {/* Diálogo para descripción del nuevo juego */}
            <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
                <DialogTitle>Nuevo juego de básquet</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Descripción del juego"
                        fullWidth
                        value={newDescription}
                        onChange={(e) => setNewDescription(e.target.value)}
                        placeholder="Ej. Amistoso categoría 2009 vs Tigres"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleConfirmCreate}
                        color="primary"
                        variant="contained"
                        disabled={!newDescription.trim()}
                    >
                        Crear
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default BasketballEventsList;
